import apiRequest from "@services/request.js";
import {handleError} from "@/utils.js";

export const MUTATIONS = {
  SET_PROFILE: 'SET_PROFILE',
  SET_META: 'SET_META',
};

export const GETTERS = {
  ADMIN_ID: 'ADMIN_ID',
};

export const ACTIONS = {
  'FETCH_PROFILE': 'FETCH_PROFILE',
};

export const MODULE_NAME = 'PROFILE';

export default {
  namespaced: true,
  state() {
    return {
      user: null,
      meta: {
        initialized: false,
        loading: false,
      },
    };
  },
  getters: {
    [GETTERS.ADMIN_ID]: ({user: {user_id}}) => user_id,
  },
  mutations: {
    [MUTATIONS.SET_META](state, { payload }) {
      state.meta = {...state.meta, ...payload};
    },
    [MUTATIONS.SET_PROFILE](state, {payload}) {
      state.user = payload;
    }
  },
  actions: {
    async [ACTIONS.FETCH_PROFILE]({commit, state}, force = false) {
      if ((state.meta.initialized && !force) || state.meta.loading) {
        return;
      }

      commit(MUTATIONS.SET_META, { payload: { loading: true } });

      try {
        const { data } = await apiRequest.get('profile');

        commit(MUTATIONS.SET_PROFILE, { payload: data });
        commit(MUTATIONS.SET_META, { payload: { initialized: true } });
      } catch (e) {
        handleError(e);
      } finally {
        commit(MUTATIONS.SET_META, { payload: { loading: false } });
      }
    }
  }
};
